// extracted by mini-css-extract-plugin
module.exports = {"standaloneNoticeBannerContainer":"style-module__standaloneNoticeBannerContainer____CRdw"};